import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

function Navbar({ user, logout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <span className="logo-text">Liber Astro</span>
        </Link>

        <div className="navbar-links">
          <Link to="/listings" className="nav-link">Listings</Link>
          
          {user ? (
            <>
              {user.userType === 'buyer' && (
                <Link to="/buyer-portal" className="nav-link">Buyer Portal</Link>
              )}
              {user.userType === 'seller' && (
                <Link to="/seller-portal" className="nav-link">Seller Portal</Link>
              )}
              {/* Attorney Portal hidden for MVP
              {user.userType === 'attorney' && (
                <Link to="/attorney-portal" className="nav-link">Attorney Portal</Link>
              )}
              */}
              {/* Third Party Portal hidden for MVP
              {user.userType === 'third_party' && (
                <Link to="/third-party-portal" className="nav-link">Partner Portal</Link>
              )}
              */}
              {user.userType === 'mls_agent' && (
                <Link to="/mls-agent-portal" className="nav-link">MLS Agent Portal</Link>
              )}
              <span className="nav-user">{user.firstName}</span>
              <button onClick={handleLogout} className="nav-btn logout-btn">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-btn login-btn">Log In</Link>
              <Link to="/signup" className="nav-btn signup-btn">Sign Up</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
